@if (filter.type === 'text' && filter.userHasAccess) {
  <text-filter
    [(text)]="filter.value"
    [placeHolder]="filter.placeholder"
    (textChange)="handleChange($event)"
  ></text-filter>
}

@if (filter.type === 'select' && filter.userHasAccess) {
  <select-component
    [items]="filter.selectItems"
    [value]="filter.value"
    [placeholder]="filter.placeholder"
    (valueChange)="handleChange($event)"
  ></select-component>
}

@if (filter.type === 'toggle' && filter.userHasAccess) {
  <div [ngStyle]="{ width: '180px' }">
    <h3 [ngStyle]="{ 'margin-top': 0, 'font-weight': 100 }">
      <i class="{{ filter.icon }}"></i>&nbsp;{{ filter.placeholder }}
    </h3>
    <div
      [hidden]="!filter.service.loading"
      [ngStyle]="{float: 'left', 'text-align': 'left', 'font-size': '16pt', 'margin-bottom': '10px'}"
      >
      <img alt="Loading" src="/images/loading.gif" [ngStyle]="{ height: '30px' }" />
    </div>
    <div [hidden]="filter.service.loading">
      <slide-toggle color="warn" (valueChange)="handleChange($event)"></slide-toggle>
    </div>
  </div>
}
